import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Btn } from '../../../../AbstractElements';
import { Close, SaveChanges } from '../../../../Constant';

const CommonModal = (props) => {
  return (
    <Modal isOpen={props.isOpen} toggle={props.toggler} size={"lg"} centered>
      <ModalHeader toggle={props.toggler}>
       <span style={{color:"#6ec6ec"}}> {props.title}</span>
      </ModalHeader>
      <ModalBody className={props.bodyClass}>
        {props.children}
      </ModalBody>
      <ModalFooter>
        <Btn attrBtn={{ color: 'secondary', onClick: props.toggler }}  >{props.closeBtnTxt}</Btn>
        {!props.disableSaveBtn ? (<Btn attrBtn={{ color: 'success', onClick: props.submitFeedbackHandler, name:'endorse_button', value:'recommended' }}>{props.saveBtnTxt}</Btn>) : null}
        {props.PSorOther || props.approverType==="committee_approver" ? (<Btn attrBtn={{ color: 'warning', onClick: props.submitFeedbackHandler, value:'not_recommended', name:'reject_button' }}>{props.rejectBtnTxt}</Btn>) : null}
      </ModalFooter>
    </Modal>
  );
};

export default CommonModal;